import { useState, type FC } from 'react'

import { Modal } from '@/components/elements'
import { MENU } from '@/constants/common/message.constants'
import { type UserMeExEntity } from '@/libs/api'

import { ShipmentOrderFormModalContent } from './ShipmentOrderFormModalContent'

export type Props = {
  authUser: UserMeExEntity
  tenantKey: string
  shippingDate: string
  open: boolean
  onClose: () => void
  // 作成成功時に呼ばれる（一覧など、react-query 以外で表示を持つ画面の再取得用）
  onCreated?: () => void
}

/**
 * 配送依頼作成モーダル。
 * `ShipmentOrderFormModalContent` の `mode="create"` を薄くラップしたもの
 * （未配車編集モーダルと本体を共有する）。
 */
export const ShipmentOrderCreateModal: FC<Props> = ({
  authUser,
  tenantKey,
  shippingDate,
  open,
  onClose,
  onCreated
}) => {
  // 保存中はモーダルを閉じられないようにするためのState
  const [isCancelDisabled, setIsCancelDisabled] = useState(false)

  return (
    <Modal
      title={MENU.CREATING_SHIPMENT_ORDER}
      width={860}
      open={open}
      onCancel={isCancelDisabled ? undefined : onClose}
      centered
    >
      <ShipmentOrderFormModalContent
        mode="create"
        authUser={authUser}
        tenantKey={tenantKey}
        shippingDate={shippingDate}
        onClose={onClose}
        setIsCancelDisabled={setIsCancelDisabled}
        onCreated={onCreated}
      />
    </Modal>
  )
}
